import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    confirmationMessage: (name: string) => string | React.ReactNode;
    deleteWorkspaceConfirmButton: string;
    deleteWorkspaceLoading: string;
    deleteWorkspaceTitle: string;
    errorMessage: (name: string) => string | React.ReactNode;
    genericErrorMessage: string;
    successMessage: (name: string) => string | React.ReactNode;
};
export type Deps = {
    truncateName: any;
};
export default {
    DEFINE(_messages: Text, { truncateName }: Deps): void {
        return Object.defineProperties(this, {
            /** Confirmation dialog message for deleting a workspace */
            confirmationMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => { const truncatedName = truncateName(name, 30); return __intl__.intl().formatMessage({ id: "useDeleteWorkspace.confirmationMessage.0?c=21fbfvlxmbb3g", defaultMessage: "<jsx>Are you sure you want to delete <strong>\"{truncatedName}\"</strong>? All Projects within this Workspace will be permanently deleted. This cannot be undone.</jsx>" }, { jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), strong: (__children__: React.ReactNode) => <strong>{React.Children.toArray(__children__)}</strong>, truncatedName: truncatedName }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Confirm button label for deleting a workspace */
            deleteWorkspaceConfirmButton: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDeleteWorkspace.deleteWorkspaceConfirmButton?c=2d2dhhv5dcywu", defaultMessage: "Delete Workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast label shown while deleting a workspace */
            deleteWorkspaceLoading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDeleteWorkspace.deleteWorkspaceLoading?c=3gdstkj81g516", defaultMessage: "Deleting Workspace\u2026" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for workspace deletion */
            deleteWorkspaceTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDeleteWorkspace.deleteWorkspaceTitle?c=1h431aebxd5yr", defaultMessage: "Delete Workspace?" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when deletion fails for a specific workspace */
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => { const truncatedName = truncateName(name); return __intl__.intl().formatMessage({ id: "useDeleteWorkspace.errorMessage.0?c=ro0b13f3t144", defaultMessage: "Failed to delete the Workspace \"{truncatedName}\"" }, { truncatedName: truncatedName }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Generic error message for workspace deletion failures */
            genericErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useDeleteWorkspace.genericErrorMessage?c=1zk3qwam3ifgr", defaultMessage: "Failed to delete the Workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success message when a workspace is deleted */
            successMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => { const truncatedName = truncateName(name, 15); return __intl__.intl().formatMessage({ id: "useDeleteWorkspace.successMessage.0?c=hrd3fhvir8f0", defaultMessage: "\"{truncatedName}\" Workspace was deleted" }, { truncatedName: truncatedName }); });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
